import PropTypes from "prop-types";
import React, { Component } from "react";
import Dashboard from "containers/Homeowner/Dashboard";
import QualityAssuranceDashboard from "containers/QualityAssurance/Dashboard";
import FieldSurveyDashboard from "components/Homeowner/Dashboard/FieldSurveyDashboard";
import InsuranceCustomerDashboard from "components/Homeowner/Dashboard/InsuranceCustomerDashboard";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gotInitialGridFilters: false,
      gotInitialGridFilterMenus: false
    };
  }

  componentDidMount() {
    if (this.props.getGridFilters) {
      this.props.getGridFilters();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.getGridFilters) {
      if (
        prevProps.isFetchingGridFilters === true &&
        this.props.isFetchingGridFilters === false
      ) {
        this.props.getGridFilterMenus();
        this.setState({
          gotInitialGridFilters: true
        });
      }
      if (this.state.gotInitialGridFilters === true) {
        if (
          prevProps.isFetchingGridFilterMenus === true &&
          this.props.isFetchingGridFilterMenus === false
        ) {
          this.setState({
            gotInitialGridFilterMenus: true
          });
        }
      }
    }
  }

  render() {
    if (this.props.getGridFilters && this.props.getGridFilterMenus) {
      if (
        !this.state.gotInitialGridFilters ||
        !this.state.gotInitialGridFilterMenus
      ) {
        return null;
      }
    }
    const user = this.props.user;
    const { token, firstName, lastName, username, email, dashboard } = user;

    if (dashboard) {
      const SelectedDashboard = {
        "Dashboard": Dashboard,
        "QualityAssuranceDashboard": QualityAssuranceDashboard,
        "FieldSurveyDashboard": FieldSurveyDashboard,
        "InsuranceCustomerDashboard": InsuranceCustomerDashboard
      }[dashboard];
      return <SelectedDashboard />;
    }
    else {
      // all other types of user gets the cheapness dashboard
      return (
        <div className="md-grid md-cell">
          <h1>Mueller</h1>
          <div>
            <div>
              You are an authorized user and your token is
              <span>
                {" "}
                <b>{token}</b>{" "}
              </span>
            </div>
            <div>
              Welcome back{" "}
              <span>
                {" "}
                <b>
                  {" "}
                  {firstName} {lastName}{" "}
                </b>{" "}
              </span>
            </div>
            <div>
              Your username is{" "}
              <span>
                {" "}
                <b> {username} </b>{" "}
              </span>
            </div>
            <div>
              Your email is{" "}
              <span>
                {" "}
                <b> {email} </b>{" "}
              </span>
            </div>
          </div>
        </div>
      );
    }
  }
}

Home.propTypes = {
  user: PropTypes.object.isRequired,
  getGridFilters: PropTypes.func,
  getGridFilterMenus: PropTypes.func,
  isFetchingGridFilters: PropTypes.bool,
  isFetchingGridFilterMenus: PropTypes.bool
};

export default Home;
